<template>
  <div>
    <b-row class="pl-2 pr-2">
      <b-col class="col-md-12 col-12 text-left">
        <h4 class="mb-3">How it works</h4>
        <h6 class="font-weight-bold">Trips as a salaried employee:</h6>
        <p>
          If you receive a travel allowance, or your employer provides you with
          a company car, then you are REQUIRED to keep a detailed record of all
          work related travel in a logbook like this one. If you don't, SARS
          will disallow your deductions completely against these allowances and
          you will end up paying more tax.
        </p>
        <p>
          Trips between home and office can NOT be claimed as work travel. If
          you travel from a client directly home, and this trip is further than
          the distance between your office and home, then you can calculate the
          business mileage by deducting the km's of the trip between home and
          office from the total km's of the client to home trip.
        </p>
        <p>For example:</p>
        <ul>
          <li>Last customer to home = 18km</li>
          <li>Office to home = 10km</li>
          <li>Business travel = 8km (18km - 10km)</li>
        </ul>
        <p>
          Keep a record of ALL fuel/oil and maintenance/repair costs throughout
          the year too, as these values are used by your employer and SARS at
          year end.
        </p>

        <p>
          On your tax return under either "Travel Claim Against Allowance" or
          "Employer Provided Vehicle", you would put all your vehicle details,
          opening and closing total km's and business km's travelled. You would
          also indicate the vehicle expenses paid by YOU, not your employer. If
          you earn commission income (code 3606 on your IRP5) then these amounts
          can be listed under the "Other deductions" section of your tax return
          as "Travel Expenses" (4015).
        </p>
        <h6 class="font-weight-bold mb-3">
          Trips as a self-employed person running a local business:
        </h6>
        <p>
          If you are self-employed and want to claim your business mileage as a
          tax deduction, then you are REQUIRED to keep a detailed record of all
          work related travel in a logbook like this one.
        </p>
        <p>
          Keep a record of all travel expenses including fuel/oil,
          maintenance/repair and license fees. The portion of these expenses
          related to business income can be deducted on your ITR12. Record ALL
          mileage specifically travelled for business-related trips, NOT
          personal trips. This includes trips from home to meetings. SARS will
          only allow you to deduct travel expenses which relate directly to
          income earning activities.
        </p>
        <p>
          On your tax return you can include all your actual business expenses
          related to your vehicle within the section called "Local Business,
          Trade and Professional Income".
        </p>
        <hr />
        <p class="mb-0">
          Have a question ?<a
            href="https://www.taxtim.com/za/help/ask-a-tax-question?ask=expert"
            target="_blank"
          >
            Drop us a line and we will gladly help you.
          </a>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HowTo"
};
</script>

<style scoped></style>
